module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "in_review.c18fb5ff.svg";